import { render, staticRenderFns } from "./ViewAdminAnnouncement.vue?vue&type=template&id=b60291b6&scoped=true&"
import script from "./ViewAdminAnnouncement.vue?vue&type=script&lang=js&"
export * from "./ViewAdminAnnouncement.vue?vue&type=script&lang=js&"
import style0 from "./ViewAdminAnnouncement.vue?vue&type=style&index=0&id=b60291b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b60291b6",
  null
  
)

export default component.exports